var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 168,
    viewBox: "0 0 312 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_287_691",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 312,
    height: 168
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9268 0.484802H291.073C302.363 0.484802 311.515 9.63701 311.515 20.9268V147.073C311.515 158.363 302.363 167.515 291.073 167.515H20.9268C9.63699 167.515 0.484802 158.363 0.484802 147.073V20.9268C0.484802 9.63701 9.63701 0.484802 20.9268 0.484802Z",
    fill: "white",
    fillOpacity: 0.9,
    stroke: "url(#paint0_linear_287_691)",
    strokeWidth: 0.969604
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_287_691)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 35,
    width: 25.8056,
    height: 133.434,
    fill: "#F8FAFC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 155.846,
    width: 25.8056,
    height: 12.5881,
    fill: "#C084FC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 81.9116,
    y: 35,
    width: 25.8056,
    height: 133.434,
    fill: "#F8FAFC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81.9116,
    y: 106.123,
    width: 25.8056,
    height: 62.311,
    fill: "#2563EB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 122.822,
    y: 35,
    width: 25.8056,
    height: 133.434,
    fill: "#F8FAFC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 122.822,
    y: 148.922,
    width: 25.8056,
    height: 19.5115,
    fill: "#FB923C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 163.734,
    y: 35,
    width: 25.8056,
    height: 133.434,
    fill: "#F3F4F6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 163.734,
    y: 130.669,
    width: 25.8056,
    height: 37.7643,
    fill: "#22C55E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 204.645,
    y: 35,
    width: 25.8056,
    height: 133.434,
    fill: "#F3F4F6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 204.645,
    y: 59.5469,
    width: 25.8056,
    height: 108.887,
    fill: "#C002A2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 245.556,
    y: 35,
    width: 25.8056,
    height: 133.434,
    fill: "#F3F4F6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 245.556,
    y: 106.123,
    width: 25.8056,
    height: 62.311,
    fill: "#0EA5E9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_287_691",
    x1: -28.0124,
    y1: -12,
    x2: 202.231,
    y2: 372.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEAEAE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.de4ece28c5091e30c9b02146c0e30bcd.svg";
export { ForwardRef as ReactComponent };